const newModel = () => {
    return {
        thethaoDoiId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        thethaoBomonId: null,
        tenThethaoBomon: null,
        thethaoHangcanId: null,
        tenThethaoHangcan: null,
        huanLuyenVienInfo: [],
        vanDongVienInfo: [],
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoDoiId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        huanLuyenVienInfo: [],
        vanDongVienInfo: [],
        listHuanLuyenVienId: [],
        listVanDongVienId: [],
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoDoiId: item.thethaoDoiId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        thethaoBomonId: item.thethaoBomonId,
        tenThethaoBomon: item.tenThethaoBomon,
        thethaoHangcanId: item.thethaoHangcanId,
        tenThethaoHangcan: item.tenThethaoHangcan,
        huanLuyenVienInfo: item.huanLuyenVienInfo,
        vanDongVienInfo: item.vanDongVienInfo,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoDoiId: item.thethaoDoiId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        thethaoBomonId: item.thethaoBomonId,
        thethaoHangcanId: item.thethaoHangcanId,
        //custom
        // huanLuyenVienInfo: item.huanLuyenVienInfo,
        // vanDongVienInfo: item.vanDongVienInfo,
        //
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        thethaoDoiId: null,
        ten: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        thethaoDoiId: item.thethaoDoiId,
        ten: item.ten,
        thethaoBomonId: item.thethaoBomonId,
        thethaoHangcanId: item.thethaoHangcanId,
        enabled: item.enabled,
    }
}


const errors = () => {
    return {
        thethaoDoiId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        huanLuyenVienInfo: null,
        vanDongVienInfo: null,
        listHuanLuyenVienId: null,
        listVanDongVienId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

export const doiTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


